<template>
  <div class="certificate-page">
    <div class="page-title">
      <p class="title-text">证书查询</p>
      <p class="text-en">Certificate Verification</p>
      <p class="text-msg">请选择查询条件（如证书编号、参赛院校等），填写后点击【查询】即可获取证书信息。</p>
    </div>
    <div class="certificate-box">
      <div class="certificate-tabs">
        <div 
          class="tab-item" 
          :class="{ active: activeTab === 'award' }"
          @click="switchTab('award')"
        >获奖证书</div>
        <div 
          class="tab-item" 
          :class="{ active: activeTab === 'teacher' }"
          @click="switchTab('teacher')"
        >指导教师证书</div>
      </div>
      <div class="certificate-form" v-if="!showResult">
        <div class="input-row">
          <div class="input-item">
            <span class="item-required">*</span>
            <span class="item-label">{{ activeTab === 'award' ? '证书编号' : '姓名' }}</span>
            <input type="text" class="item-input" v-model="formData.field1">
          </div>
          <div class="input-item">
            <span class="item-required">*</span>
            <span class="item-label">{{ activeTab === 'award' ? '参赛院校' : '院校名称' }}</span>
            <div class="item-select">
              <el-select v-model="formData.field2" filterable remote placeholder="" :remote-method="searchSchool">
                <el-option
                    v-for="item in arrSchool"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="btn-box">
          <div class="btn-query" @click="handleQuery">查&nbsp;&nbsp;&nbsp;询</div>
        </div>
      </div>
      <div class="certificate-result" v-else>
        <div class="result-item" v-for="item in certificateList" :key="item.id">
          <span class="result-label" @click="previewCertificate(item)">{{ item.name }}</span>
          <span class="result-download" @click="download(item)">下载</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getSearchSchoolFilter, searchAwardCertificate, searchTeacherCertificate} from "@/request/api";
export default {
  name: "Certificate",
  components:{

  },
  data() {
    return {
      activeTab: 'award',
      showResult: false,
      arrSchool: [],
      certificateList: [],

      formData: {
        field1: '',
        field2: ''
      }
    }
  },
  computed: {},
  created() {
    
  },
  mounted() {
  },
  methods: {
    async handleQuery() {
      if (!this.formData.field1.trim()) {
        this.$message.warning(this.activeTab === 'award' ? '请填写证书编号' : '请填写姓名')
        return
      }
      
      if (!this.formData.field2.trim()) {
        this.$message.warning(this.activeTab === 'award' ? '请填写参赛院校' : '请填写院校名称')
        return
      }
      
      try {
        let res
        if (this.activeTab === 'award') {
          res = await searchAwardCertificate({
            certificateNo: this.formData.field1,
            school: this.formData.field2
          })
        } else {
          res = await searchTeacherCertificate({
            teacherName: this.formData.field1,
            school: this.formData.field2
          })
        }
        
        if (res && res.data) {
          this.certificateList = Array.isArray(res.data) ? res.data : [res.data]
          this.showResult = true
        } else {
          this.$message.warning('没有找到对应的证书')
        }
      } catch (error) {
        console.log('查询失败:', error)
      }
    },
    switchTab(tab){
      this.activeTab = tab;
      this.showResult = false;
      this.formData.field1 = '';
      this.formData.field2 = '';
      this.certificateList = [];
    },
    searchSchool(key){
      const requestData = {
        school: key,
      };
      getSearchSchoolFilter(requestData).then((res)=>{
        this.arrSchool = res.data;
      })
    },
    download(item){
      if (this.activeTab === 'award') {
        let url = process.env.VUE_APP_SERVER_URL + "/works/award/download?id=" + item.id + "&certificateNo=" + item.name;
        window.open(url, '_blank');
      } else {
        let url = process.env.VUE_APP_SERVER_URL + "/works/award/search/teach/download?fileName=" + item.id;
        window.open(url, '_blank');
      }
    },
    previewCertificate(item){
      let url;
      if (this.activeTab === 'award') {
        url = process.env.VUE_APP_SERVER_URL + "/works/award/preview?id=" + item.id + "&certificateNo=" + item.name;
      } else {
        url = process.env.VUE_APP_SERVER_URL + "/works/award/search/teach/preview?fileName=" + item.id;
      }
      window.open(url, '_blank');
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/css/var";
.certificate-page{
  width: 100%;
  background: #FFF;
  overflow: hidden;
  .page-title{
    width: 1050px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 100px;
    text-align: center;
    .title-text{
      font-size: $titleZhSize;
      font-weight: 600;
      color: #1A1A1A;
    }
    .text-en{
      font-size: $titleEnSize;
      font-style: italic;
      color: #FF3B30;
      margin-top: 5px;
    }
    .text-msg{
      font-size: 16px;
      font-weight: 400;
      color: #7A7979;
      margin-top: 20px;
    }
  }
  .certificate-box{
    width: 1050px;
    margin-bottom: 100px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    background: #FFF;
    border-radius: 8px;
    box-shadow: 0 10px 40px rgba(255, 59, 48, 0.15);
    padding: 60px 0;
    overflow: hidden;

    .certificate-tabs{
      display: flex;
      justify-content: center;
      gap: 10px;
      margin-bottom: 50px;
      .tab-item{
        padding: 8px 24px;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
        background: #FFF;
        border: 1px solid #FF3B30;
        color: #FF3B30;
        &.active{
          background: #FF3B30;
          color: #FFF;
        }
      }
    }

    .certificate-form{
      .input-row{
        display: flex;
        justify-content: center;
        gap: 60px;
      }
      .input-item{
        display: flex;
        align-items: center;
        gap: 8px;
        .item-required{
          color: #FF3B30;
          font-size: 14px;
        }
        .item-label{
          font-size: 14px;
          color: #333;
          width: 70px;
        }
        .item-input{
          width: 259px;
          height: 33px;
          border-radius: 4px;
          border: 1px solid #FF3B30;
          padding: 0 10px;
          font-size: 12px;
          outline: none;
          &:focus{
            border-color: #FF3B30;
          }
        }
        .item-select{
          width: 259px;
          height: 33px;
          border-radius: 4px;
          border: 1px solid #FF3B30;
        }
      }
      .btn-box{
        display: flex;
        justify-content: center;
        margin-top: 40px;
        .btn-query{
          width: 221px;
          height: 33px;
          line-height: 33px;
          font-size: 14px;
          text-align: center;
          color: #FFFFFF;
          cursor: pointer;
          border-radius: 4px;
          background: #FF3B30;
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
        }
      }
    }

    .certificate-result{
      padding: 20px 100px;
      .result-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        border-bottom: 1px dashed #E5E5E5;
        .result-label{
          font-size: 14px;
          color: #333;
          cursor: pointer;
          &:hover{
            color: #FF3B30;
          }
        }
        .result-download{
          font-size: 14px;
          color: #FF3B30;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style>
.el-input{
  width: 255px;
}
.el-input__inner{
  height: 31px;
  line-height: 31px;
  border: none;
}
.el-input__suffix{
  height: 12px;
  width: 12px;
  margin-top: 10px;
  margin-right: 10px;
  background: url(~@/assets/icon_select_arrow.png) no-repeat;
  background-size: cover;
}
</style>